import {callApi} from "./rest.js";

const ROOT_URL = '/api/alterations';

export const getAlterationSuggestion = async (query) => {
    const url = `${ROOT_URL}/suggest?q=${query}`;
    return await callApi(url, "GET");
};